const BanzaTextEditPresets = {
  BanzaTextEdit: {
    class: "banza-edit banza-text-edit",
    attrs: {
      density: "compact",
      variant: "outlined"
    },
    slots: {
      disabled: {
        icon: {
          attrs: {
            class: "disabled-icon",
            size: "16",
            icon: "$b-disabled"
          }
        }
      }
    },
    presets: {
      search: {
        class: "banza-search",
        slots: {
          prependInner: {
            icon: {
              attrs: {
                icon: "mdi-magnify"
              }
            }
          }
        }
      },
      dateEdit: {
        props: {
          dateFormatter: "ll"
        },
        slots: {
          calendar: {
            class: "bnz-icon--btn-wrap d-flex justify-center align-center icon--btn",
            icon: {
              attrs: {
                icon: "lets-icons:calendar-duotone",
                size: 16
              }
            }
          }
        }
      }
    }
  }
};
export {
  BanzaTextEditPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
